// extracted by mini-css-extract-plugin
export default {"main":"input_main__lv1Av","inputText":"input_inputText__bgvY0","error":"input_error__FVAXr","selectBtn":"input_selectBtn__yKXyE"};